/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Saved_NewInputs */

const en_us2_profile_editors_pain_saved_new = /** @type {(inputs: Profile_Editors_Pain_Saved_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pain logged: the plan will adapt`)
};

const pt_br2_profile_editors_pain_saved_new = /** @type {(inputs: Profile_Editors_Pain_Saved_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor registrada: o plano vai se adaptar`)
};

const es_419_profile_editors_pain_saved_new = /** @type {(inputs: Profile_Editors_Pain_Saved_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolor registrado: el plan se adaptará`)
};

const pt_pt2_profile_editors_pain_saved_new = /** @type {(inputs: Profile_Editors_Pain_Saved_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor registada: o plano vai adaptar-se`)
};

const fr_fr2_profile_editors_pain_saved_new = /** @type {(inputs: Profile_Editors_Pain_Saved_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Douleur enregistrée : le programme va s'adapter`)
};

const de_de2_profile_editors_pain_saved_new = /** @type {(inputs: Profile_Editors_Pain_Saved_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schmerz eingetragen: Der Plan passt sich an`)
};

const it_it2_profile_editors_pain_saved_new = /** @type {(inputs: Profile_Editors_Pain_Saved_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolore registrato: la scheda si adatterà`)
};

/**
* | output |
* | --- |
* | "Pain logged: the plan will adapt" |
*
* @param {Profile_Editors_Pain_Saved_NewInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_saved_new = /** @type {((inputs?: Profile_Editors_Pain_Saved_NewInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Saved_NewInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_saved_new(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_saved_new(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_saved_new(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_saved_new(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_saved_new(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_saved_new(inputs)
	return en_us2_profile_editors_pain_saved_new(inputs)
});
export { profile_editors_pain_saved_new as "profile-editors.pain_saved_new" }